import { SatisfactionScore } from '../models/satisfaction.model';

export abstract class WellbeingRepository {
  abstract loadScore(date: string): Promise<SatisfactionScore | null>;
  abstract saveScore(date: string, score: SatisfactionScore): Promise<void>;
  abstract clearScore(date: string): Promise<void>;
}
